import { useEffect } from "react";
import { X } from "lucide-react";

/**
 * RgModal — modal générique pour les écrans /admin/gestion/*.
 * Fermeture par overlay ou touche Escape. Focus trap léger.
 */
export function RgModal({ open, onClose, title, children, maxWidth = 640, testid }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div
      data-testid={testid}
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, zIndex: 100,
        background: "rgba(45, 48, 46, 0.55)",
        display: "flex", alignItems: "flex-end", justifyContent: "center",
        padding: "40px 12px 12px",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#FAF8F5", borderRadius: "18px 18px 12px 12px",
          width: "100%", maxWidth,
          maxHeight: "88vh", overflow: "auto",
          padding: 22,
          boxShadow: "0 -8px 40px rgba(0,0,0,0.25)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
          <h3 style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>{title}</h3>
          <button onClick={onClose} style={{ background: "transparent", border: 0, cursor: "pointer", color: "#6B6E6C", padding: 4 }}>
            <X size={18} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
